import React, { useState } from 'react';
import { DeveloperBanner } from "../../constants/ImagePaths"
import { SimplifyBackground } from "../../constants/ImagePaths";
import Image from '../../components/general/Image';
import Button from '../../components/general/Button';
import { useSelector } from 'react-redux';
import { ROUTES } from '../../routes/RouteList';
import RegistrationCardFormModal from '../../components/common/RegistrationCardFormModal';
import { ArrowUpRight } from '../../components/common/Icons';

const SimplifySection = () => {
  const backgroundImage = {
    backgroundImage: `url(${SimplifyBackground})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    zIndex: '2',
  }

  const [showRegisterFormModal, setShowRegisterFormModal] = useState(false);

  const { developer: { detail } } = useSelector(state => state.common);

  return (
    <section className="-mt-[45px] py-[50px] lg:pb-0" style={backgroundImage}>
      <div className="text-black md:flex lg:justify-between lg:items-end --layout-padding max-width">
        <div className="lg:w-[30%]">
          <figure className='lg:bottom-[25px]'><Image className='w-[100%]' src={DeveloperBanner} alt=""/></figure>
        </div>
        <div className="content-block mt-[30px] lg:w-[60%]">
          <h4 className='text-[30px] lg:text-[40px] font-semibold md:text-right'>Hire {detail.first_name} </h4>
          <p className='text-right text-[20px] text-white font-extralight'>or someone with similar qualifications in days.</p>
          <div className="text-end my-[30px]">
            <Button onClick={() => setShowRegisterFormModal(true)} className='btn-outline-white border border-white rounded h-[50px] w-full md:w-[200px] lg:w-[250px] lg:h-[60px] md:ml-auto'>
              <div className="flex items-center justify-center gap-2">
                <span>Place a Free Quote</span>
                <ArrowUpRight className="w-4 h-4" />
              </div>
            </Button>
          </div>
        </div>
      </div>
      <RegistrationCardFormModal show={showRegisterFormModal} onClose={() => setShowRegisterFormModal(false)} />
    </section>
  );
};

export default SimplifySection;